module.exports = __webpack_public_path__ + "static/media/exclaim.9f041bd1.svg";